import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 5,
    width: '100%',
    marginBottom: 10,
    position: 'absolute',
    bottom: 0
  },
  contactDetails: {
    backgroundColor: '#e4e4e4',
    borderBottomRightRadius: 100,
    borderBottomLeftRadius: 100,
    fontSize: 9,
    paddingVertical: 6,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    width: '84%',
    paddingHorizontal: 10
  },
  itemContainer: {
    flexDirection: 'row-reverse',
    fontSize: 10
  },
  iconsFooter: {
    width: 130,
    alignItems: 'center',
    justifyContent: 'center'
  },
  tenantImgContainer: {
    height: 30
  },
  img: {
    height: 30
  },
  emoji: {
    marginTop: 1,
    marginLeft: 3
  },
  adotelText: {
    marginTop: 8,
    fontSize: 9
  },
  adotelImgContainer: {
    marginTop: 7,
    height: 15,
    marginRight: 3
  },
  adotelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }
})
export default styles
